import makeStyles from '@mui/styles/makeStyles';

interface PDFPreviewStyleProps {
  isOnMediaPage: boolean;
}

const useStyles = makeStyles(() => ({
  pdfWrapper: (props: PDFPreviewStyleProps) => ({
    width: props.isOnMediaPage ? '90%' : '100%',
    display: 'flex',
    justifyContent: 'center',
  }),
  controlPanel: {
    position: 'sticky',
    top: 0,
    zIndex: 1000,
  },
  pdfDocument: () => ({
    width: '100%',
    height: '100%',
  }),

  pdfPage: (props: PDFPreviewStyleProps) => ({
    '@media (max-width: 1600px)': {
      width: props.isOnMediaPage ? '75%' : '100%',
    },
    height: '100%',
  }),
  '@media (max-width: 1600px)': {
    pdfWrapper: (props: PDFPreviewStyleProps) => ({
      width: props.isOnMediaPage ? 'calc(100% + 10px)' : 'calc(100% - 50px)',
      display: 'flex',
      justifyContent: 'center',
      '@media (max-width: 1600px)': {
        width: props.isOnMediaPage ? 'calc(60% + 250px)' : 'calc(100% - 50px)',
      },
    }),
  },
}));

export default useStyles;
